import { useEffect, useState } from "react";
import API from "../services/api";
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer,
    CartesianGrid,
    PieChart,
    Pie,
    Cell,
    Legend
} from "recharts";

export default function Analytics() {
    const [data, setData] = useState([]);
    const [statusData, setStatusData] = useState([]);

    const COLORS = ["#8b5cf6", "#22c55e", "#ef4444"];

    useEffect(() => {
        fetchAnalytics();
    }, []);

    const fetchAnalytics = async () => {
        try {
            const res = await API.get("/leads");

            const leads = res.data || [];

            // ✅ LINE CHART (Leads per day)
            const grouped = {};
            leads.forEach((lead) => {
                const date = new Date(lead.createdAt).toLocaleDateString();
                grouped[date] = (grouped[date] || 0) + 1;
            });

            const chartData = Object.keys(grouped).map((key) => ({
                date: key,
                leads: grouped[key],
            }));

            setData(chartData);

            // ✅ PIE CHART (Status distribution)
            const statusCount = {
                New: 0,
                Contacted: 0,
                Closed: 0,
            };

            leads.forEach((lead) => {
                if (statusCount[lead.status] !== undefined) {
                    statusCount[lead.status]++;
                }
            });

            const formattedStatus = Object.keys(statusCount).map((key) => ({
                name: key,
                value: statusCount[key],
            }));

            setStatusData(formattedStatus);

        } catch (err) {
            console.error("Analytics error", err);
        }
    };

    return (
        <div className="p-8 text-white space-y-8">
            <h1 className="text-2xl font-bold">Analytics</h1>

            {/* 🔥 Line Chart */}
            <div className="bg-white/10 backdrop-blur-xl p-6 rounded-xl">
                <h2 className="mb-4 text-lg">Leads Over Time</h2>

                <ResponsiveContainer width="100%" height={300}>
                    <LineChart data={data}>
                        <CartesianGrid strokeDasharray="3 3" stroke="#333" />
                        <XAxis dataKey="date" stroke="#aaa" />
                        <YAxis stroke="#aaa" />
                        <Tooltip />
                        <Line
                            type="monotone"
                            dataKey="leads"
                            stroke="#8b5cf6"
                            strokeWidth={3}
                        />
                    </LineChart>
                </ResponsiveContainer>
            </div>

            {/* 🔥 Pie Chart */}
            <div className="bg-white/10 backdrop-blur-xl p-6 rounded-xl">
                <h2 className="mb-4 text-lg">Lead Status Distribution</h2>

                <ResponsiveContainer width="100%" height={300}>
                    <PieChart>
                        <Pie
                            data={statusData}
                            dataKey="value"
                            nameKey="name"
                            outerRadius={100}
                            label
                        >
                            {statusData.map((entry, index) => (
                                <Cell
                                    key={`cell-${index}`}
                                    fill={COLORS[index % COLORS.length]}
                                />
                            ))}
                        </Pie>
                        <Legend />
                        <Tooltip />
                    </PieChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
}